/* Custom JavaScript belongs in this file and will compile into a minified file */

/* Exmaple for responsive background images here - https://aclaes.com/responsive-background-images-with-srcset-and-sizes/ */

'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResponsiveBackgroundImage = function () {
    function ResponsiveBackgroundImage(element) {
        var _this = this;

        _classCallCheck(this, ResponsiveBackgroundImage);

        this.element = element;
        this.img = element.querySelector('img');
        this.src = '';
        if (!this.element || !this.img) {
            return false;
        }

        this.img.addEventListener('load', function () {
            _this.update();
        });

        if (this.img.complete) {
            this.update();
        }

    }

    _createClass(ResponsiveBackgroundImage, [{
        key: 'update',
        value: function update() {
            var src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
            if (this.src !== src) {
                this.src = src;
                this.element.style.backgroundImage = 'url("' + this.src + '")';
            }
        }
    }]);

    return ResponsiveBackgroundImage;
}();

function init() {

	//-- There is an defer image load availble here if required

	//var imgDefer = document.getElementsByTagName('img');
	//for (var i=0; i<imgDefer.length; i++) {
	//	if(imgDefer[i].getAttribute('data-src')) {
	//		imgDefer[i].setAttribute('src',imgDefer[i].getAttribute('data-src'));
	//	} 
	//}
	
	var elements = document.querySelectorAll('[data-responsive-background-image]');
		for (var i = 0; i < elements.length; i++) {
		    new ResponsiveBackgroundImage(elements[i]);
		}
}
window.onload = init;

$(document).ready(function(){
    $('.hero-slider-container').slick({
        arrows: false,
        dots: true,
        lazyLoad: 'ondemand',
        autoplay: true,
        autoplaySpeed: 7500,
    });

    var numSlides = screen.width/320;

    $('.instagram-slider').slick({
        arrows: false,
        infinite: true,
        slidesToShow: numSlides,
        lazyLoad: 'ondemand',
        responsive: [{
            breakpoint: 599,
            settings: {
                slidesToShow: 1,
            }
        }]
    });

    $('#js-stories-carousel').slick({
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 3,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 599,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    dots: true,
                    arrows: false,
                }
            }
        ]
    });

    var header  = $('.header');

                var didScroll = false;
                $(window).on('scroll', function() {
                    didScroll = true;
                })

                setInterval(function() {
                    if(didScroll){
                        didScroll = false;

                        // Find scroll position from top of page
                        var scrollPos = window.pageYOffset;

                        if(scrollPos > 0){
                            header.css('background-color', '#2B3E42')
                            header.addClass('scrolled');
                        }
                        else {
                            header.css('background-color', 'rgba(0,0,0,0)')
                            header.removeClass('scrolled');
                        }
                    }
                } , 50)
                

                $('#close-mobile-menu').click(function() {
                    $('.mobile-menu').removeClass('is-active')
                    $('.menu-toggle').removeClass('is-active')
                })


    var menuCallButton = document.querySelector(".menu-call-button");
    var menuCallDropdown = document.querySelector(".menu-call-button__list");

    if (menuCallButton !== null && menuCallDropdown !== null) {
        menuCallButton.addEventListener('click', function() {
            menuCallDropdown.classList.toggle("active");
        })
    }

    var mobileMenuTrigger = document.querySelector(".mobile-menu-trigger");
    var mobileMenu = document.querySelector(".mobile-menu-dropdown");
    var mobileHeader = document.querySelector(".header");

    if (mobileMenuTrigger !== null) {
        mobileMenuTrigger.addEventListener('click', function() {
            mobileHeader.classList.toggle("active");
            mobileMenuTrigger.classList.toggle("active");
            mobileMenu.classList.toggle("active");
        })
    }

});


//add simple support for background images:
document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});